import { Button } from 'react-bootstrap';
import cx from 'classnames';
import PT from 'prop-types';
import Immutable from 'immutable';

import JeddleMultiChoiceResponse from './JeddleMultiChoiceResponse';
import { createInstructionMarkup, questionComponentPropTypes } from './helpers';
import style from './JeddleSingleAnswerMultiChoiceQuestion.scss';

const getFeedbackHtml = (question, isCorrect) => {
  if (isCorrect === true) {
    return question.get('jeddle_correct_feedback_html') || null;
  }
  if (isCorrect === false) {
    return question.get('jeddle_incorrect_feedback_html') || null;
  }
  return null;
};

const JeddleSingleAnswerMultiChoiceQuestion = ({
  question,
  quizStats,
  response,
  showResult,
  isSaving,
  isAnswered,
  isCorrect,
  onResponseChange,
  onSaveClick,
  onContinue,
}) => {
  const handleResponseChange = (e) => {
    onResponseChange(response.set('answer', parseInt(e.target.value, 10)));
  };

  const feedbackHtml = showResult ? getFeedbackHtml(question, isCorrect) : null;

  const hasAnswer = !!response.get('answer');

  return (
    <div className="question multi-choice single-answer">
      <span dangerouslySetInnerHTML={createInstructionMarkup(question)} />

      <JeddleMultiChoiceResponse
        questionId={question.get('id')}
        showResult={showResult}
        answers={question.get('answers')}
        checked={[response.get('answer')]}
        stats={quizStats}
        onChange={handleResponseChange}
        disabled={isSaving || isAnswered}
      />

      {isAnswered ? (
        <div
          className={cx(style.feedback, {
            [style.feedbackCorrect]: feedbackHtml && isCorrect === true,
            [style.feedbackIncorrect]: feedbackHtml && isCorrect === false,
          })}
        >
          {feedbackHtml && (
            <div
              className={style.feedbackMessage}
              dangerouslySetInnerHTML={{ __html: feedbackHtml }}
            />
          )}
          <Button onClick={onContinue}>Continue &raquo;</Button>
        </div>
      ) : (
        <Button
          onClick={onSaveClick}
          disabled={!hasAnswer || isSaving}
          className={style.button}
        >
          Save
        </Button>
      )}
    </div>
  );
};

JeddleSingleAnswerMultiChoiceQuestion.propTypes = {
  ...questionComponentPropTypes,
  onContinue: PT.func.isRequired,
  isAnswered: PT.bool,
  isCorrect: PT.oneOf([true, false, null]),
  showResult: PT.bool,
};

JeddleSingleAnswerMultiChoiceQuestion.defaultProps = {
  response: Immutable.Map(),
  isAnswered: false,
  isCorrect: null,
  showResult: false,
};

export default JeddleSingleAnswerMultiChoiceQuestion;
